<template>
  <v-app>
    <!-- Navbar -->
    <Header
      @toggle-mobile-menu="showMobileMenu = $event"
      :show-menu-icon="showGlobalSideMenu"
      :show-mobile-menu="showMobileMenu"
    />

    <GlobalSideMenu
      :show-mobile-menu="showMobileMenu"
      @change="showMobileMenu = $event"
      class="side-menu hidden-sm-and-down"
      v-if="showGlobalSideMenu && largeScreen"
    />
    <GlobalSideMenu
      v-if="showGlobalSideMenu && !largeScreen"
      :show-mobile-menu="showMobileMenu"
      @change="showMobileMenu = $event"
    />

    <!-- Main-->
    <v-main class="main-container">
      <div class="fill-height d-flex flex-column px-8 py-3">
        <div class="flex-grow-0 pb-3">
          <PBackButton v-if="displayBackButton" text="Back"></PBackButton>
          <QuestionnaireProgressBar
            v-if="displayQuestionnaireProgressBar"
            :step="selectedQuestionnaireStore.progress"
          />
        </div>

        <div class="flex-grow-1">
          <GlobalSnackbar />
          <slot></slot>
        </div>

        <div class="footer flex-grow-0 text-center pt-12">
          <Footer />
        </div>
      </div>
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
import Footer from "@/components/Footer.vue";
import GlobalSideMenu from "@/components/menu/GlobalSideMenu.vue";
import { onBeforeMount, ref, watch } from "vue";
import { useTrustGroupStore } from "@/stores/trustGroup";
import { useUserProfileStore } from "@/stores/userProfileStore";
import { useItemsStore } from "@/stores/itemsStore";
import { useAuthenticationStore } from "@/stores/authentication";
import { genericError } from "@/modules/utilities";
import { useSnackBarStore } from "@/stores/snackBarStore";
import GlobalSnackbar from "@/components/feedback/GlobalSnackbar.vue";
import { useDisplay } from "vuetify/lib/framework.mjs";
import Header from "@/components/header/Header.vue";
import PBackButton from "@/components/custom/buttons/PBackButton.vue";
import QuestionnaireProgressBar from "@/views/questionnaire/QuestionnaireProgressBar.vue";
import { useSelectedQuestionnaire } from "@/stores/selectedQuestionnare";

defineProps<{
  showGlobalSideMenu: boolean;
  displayBackButton: boolean;
  displayQuestionnaireProgressBar: boolean;
}>();

const trustGroupStore = useTrustGroupStore();
const userProfileStore = useUserProfileStore();
const authenticationStore = useAuthenticationStore();
const itemsStore = useItemsStore();
const snackbarStore = useSnackBarStore();
const selectedQuestionnaireStore = useSelectedQuestionnaire();

const showMobileMenu = ref(false);
const v = useDisplay();
const largeScreen = v.mdAndUp;

watch(largeScreen, (x) => {
  showMobileMenu.value = false;
});

onBeforeMount(async () => {
  try {
    await Promise.all([
      userProfileStore.setUserProfile(),
      itemsStore.setItems(),
    ]);

    if (authenticationStore.registered) {
      await Promise.all([
        trustGroupStore.setIsCustomer(),
        userProfileStore.setTrustGroup(),
      ]);
    }
  } catch (error) {
    snackbarStore.showError(genericError);
  } finally {
  }
});
</script>

<style scoped lang="scss">
.main-container {
  background-color: var(--light-grey-2);
}

.side-menu {
  max-width: 255px;
}

.footer {
  font-size: 14px;
  min-height: 64px;
  min-width: 100%;
}
</style>
